/* C-02 Data tag: square, it informs (P9). */
.tag {
  position: relative;
  display: inline-flex;
  align-items: stretch;
  vertical-align: middle;
  max-width: 100%;
  /* Narrow widths: the value drops under the label (stacked variant). */
  flex-wrap: wrap;
}
.label {
  display: inline-flex;
  align-items: center;
  gap: var(--dimension-space-1);
  padding: 3px 6px;
  background: var(--color-surface-inverse);
  color: var(--color-text-on-inverse);
}
.value {
  display: inline-flex;
  align-items: center;
  padding: 3px 7px;
  background: var(--color-surface-sunken);
  color: var(--color-text-primary);
  min-width: 0;
  overflow-wrap: break-word;
}
.signal .label,
.hazard .label {
  background: var(--color-surface-signal);
  color: var(--color-text-on-signal);
}
.hazard .label {
  padding-left: 0;
}
.stripes {
  align-self: stretch;
  width: 10px;
  margin-right: 6px;
}
.mine .label {
  background: transparent;
  color: var(--color-text-primary);
  box-shadow: inset 0 0 0 var(--dimension-line-hairline) var(--color-text-primary);
}
.icon {
  width: 0.75rem;
  height: 0.75rem;
  flex: none;
}

.group {
  display: flex;
  flex-wrap: wrap;
  gap: var(--dimension-space-1);
}
